import React, { useState,useEffect,useCallback } from "react";
import { Accordion, AccordionBody } from "../common/Accordion";
import { uploadDocument,getDocumentTypes,deleteUploadedFile, updateProfileDetail } from "../../actions/StudentAction";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faEye,faEdit,faDeleteLeft, faPlus, faTrash } from '@fortawesome/free-solid-svg-icons';
import swal from "sweetalert";
import Dialog from "../common/Dialog";


const Documents = (props) => {
  const detail=props.detail
  // const callback = useCallback();
  const [fields,setFields] = useState({value: "",error: "",options : [],isRequired: true});
  const [input,setInput] = useState({name:'',value: "",id:'',error: "",isRequired: true});
  // const[edit,setEdit]=useState(false)
  // const [isDelete, setDelete] = useState(false);
  // const [selectedId, setSelectedId] = useState(undefined);
  // const [selectEditField,setSelectEditField] = useState(false);
  // const[callBack,setCallBack]=useState(undefined)
  const [selectedDocId,setSelectedDocId]=useState(undefined)
  // const[isDoc,setIsDoc]=useState(false)

  const {admit_card,admit_card_status} = detail !==undefined && detail


  useEffect(async() => {


    const list=detail&&detail.documents!==null&&detail.documents
    const fieldRes=await getDocumentTypes()
    if(list&&list.length>0){
      fieldRes.data.forEach(i=>{
        list.forEach(e=>{
          if(e.document_id==i.id){
            i.value=e.document_value
            i.docId=e.id
          }
        })
      })
    }
    setFields({...fields, options: fieldRes.data});


  },[props.detail]);

  useEffect(() => {
    
    if(admit_card_status ==='3'){
      swal('Admit card not clearly visible or Invalid','Please re-upload','error');
    }
  },[admit_card_status])

  const onInputChange=(e,id)=>{
    let name=e.target.name
    const value=e.target.files
    setInput({...input,name:name,value:value[0],id:id})
  }

  const onSubmit = async (e) => {
    e.preventDefault(); 
    const formData = new FormData();
    // formData.append('document_id',input.id)
    // formData.append('document_name',input.name)
    formData.append('admit_card',input.value)
    formData.append('student_id',detail.id)
    const data = {
      admit_card_status : 1
    }
    data.id = detail.id
    await uploadDocument(formData).then(res => {
         if (res.status) {
          updateProfileDetail(data)
          swal(res.message,'','success')
          props.handleDocUpload(res)
        }
        else{
            swal(res.message,'','error')
        }
    })
    .catch(err => {
      console.log(err);
    })
  }

  

  // const onEditDetail = async (e,selId) => {
  //   e.preventDefault(); 
  //   const formData = new FormData();
  //   formData.append('document_id',input.id)
  //   formData.append('document_name',input.name)
  //   formData.append('document',input.value)
  //   formData.append('student_id',detail.id)
  //   formData.append('id',selId)
   
  //   await uploadDocument(formData).then(res => {
  //        if (res.status) {
  //         swal(res.message,'','success')
  //         props.handleDocUpload(res)
  //         setEdit(false)
  //         setIsDoc(false)
  //         setSelectedDocId(undefined)
  //         props.handleDocUpload(res.data)
  //       }
  //       else{
  //           swal(res.message,'','error')
  //       }
  //   })
  //   .catch(err => {
  //     console.log(err);
  //   })
  // }

  // const handleEdit=(e,id)=>{
  //   e.preventDefault();
  //   setEdit(true)
  //   setSelectedDocId(id)
  //   setIsDoc(true)
  // }

//   const handleDelete = (e,id) => {
//     e.preventDefault();
//     setDelete(true)
//     setSelectedId(id)
// };
//   const dailogSubmit = () => {
//    setDelete(false)
//   deleteItem()
// }

// const deleteItem = async() => {
//   const{documents}=detail
//   let data=documents.filter(i=>i.id==selectedId)[0]
//   const deleteData = {
//                 id: selectedId,
//                 student_id: detail.id,
//                 document_id : data.document_id
//   }

//   await deleteUploadedFile(deleteData).then(res => {
//        if (res.status) {
//         swal(res.message,'','success')
//         props.handleDelete(detail.id);
//       }
//       else{
//           swal(res.message,'','error')
//       }
//   })
//   .catch(err => {
//     console.log(err);
//   })
// }
// const onCancel = () => {
//    setDelete(false)
// }


  return (
    <>
     {/* {
        isDelete && <Dialog
            className="modal-md"
            backdrop="static"
            message="Are you sure, you want to delete this file?"
            toggleModal={dailogSubmit}
            onCancel={onCancel}>
        </Dialog>
     } */}
    <Accordion title="Upload Admit card" collapseName="documentsUpload">
      <AccordionBody>
        <form>
          <div className="row mb-4 align-items-end">
            {/* <div className="col-lg-12 mb-2"><small className="text-danger">Note : Add one image at a time**</small></div> */}
            {
              fields.options.map(item => (
                

                <React.Fragment key={item.id}>
                  <div className="col-lg-6 mb-3" >
                        <label className="default-font">
                          {item.name}
                        </label>
                        <>
                        <input type="file"
                          className="form-control" disabled={admit_card_status==='1' || admit_card_status ==='2' }
                          name={item.name} accept="image/png, image/gif, image/jpeg, pdf" onChange={(e) => onInputChange(e,item.id)}/>

                          {admit_card_status==='1' &&  <span className="text-warning d-block mt-2 ms-1 text-start ">Admit card approval pending</span>}
                          {admit_card_status==='2' &&  <span className="text-success d-block mt-2 ms-1 text-start ">Admit card Approved</span>}
                          
                         
                        </>
                        
                  </div>
                  <div className="col-lg-6 mb-3">
                  {(admit_card_status==='0' || admit_card_status==='3')  && (
                    <button type="button" className="btn btn-primary me-2" onClick={onSubmit}>Submit</button>
                  )}
                 
            
                  </div>
                  <div className="w-100"></div>
                </React.Fragment>
              ))
            }
        
            <div className="col-lg-4">
              {/* <input type="submit" className="btn btn-primary" value="Update" /> */}
            </div>
           
          </div>
        </form>
      </AccordionBody>
    </Accordion>
    </>
  );
};

export default Documents;
